import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_DEVICES = "fetchAdminDevices";
export const FETCH_ADMIN_DEVICE = "fetchAdminDevice";
export const STORE_ADMIN_DEVICE = "storeAdminDevice";
export const UPDATE_ADMIN_DEVICE = "updateAdminDevice";
export const DESTROY_ADMIN_DEVICE = "destroyAdminDevice";
export const UPDATE_ADMIN_DEVICE_STATUS = "updateAdminDeviceStatus";

// mutation types
export const SET_ADMIN_DEVICES = "setAdminDevices";
export const SET_ADMIN_DEVICES_PAGINATION = "setAdminDevicesPagination";
export const SET_ADMIN_DEVICE = "setAdminDevice";

const state = {
  adminDevices: [],
  adminDevicesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  adminDevice: {}
};

const getters = {
  adminDevices(state) {
    return state.adminDevices;
  },
  adminDevicesPagination(state) {
    return state.adminDevicesPagination;
  },
  adminDevice(state) {
    return state.adminDevice;
  }
};

const actions = {
  [FETCH_ADMIN_DEVICES](context, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("/admin/devices", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_DEVICES, data.data);
          context.commit(SET_ADMIN_DEVICES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_DEVICE](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("admin/devices", id)
        .then(({ data }) => {
          context.commit(SET_ADMIN_DEVICE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [STORE_ADMIN_DEVICE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/devices", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_DEVICE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update("admin/devices", payload.id, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_DEVICE_STATUS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`admin/devices/${payload.id}/status`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_ADMIN_DEVICE](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`admin/devices/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  }
};

const mutations = {
  [SET_ADMIN_DEVICES](state, devices) {
    state.adminDevices = devices;
  },
  [SET_ADMIN_DEVICES_PAGINATION](state, data) {
    state.adminDevicesPagination = data;
  },
  [SET_ADMIN_DEVICE](state, device) {
    state.adminDevice = device;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
